import { CURRENT_REGION } from 'config/regions/config';
import { Regions } from 'config/regions/types';
import { UserLocStore } from 'interfaces';
import dayjs from 'utils/dayjs';

const invoicesUrl = '/embed/dashboards/138';

const myInvoicesUrl = (name: string) => {
  const uriName = encodeURIComponent(name);

  return `${invoicesUrl}}?Type=&State=&Customer=&Issued=&Registered=&Payment%20due=&Paid=&Brutto%20value=&Production%20manager=${uriName}&filter_config=%7B"Type":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":18%7D%5D,"State":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":19%7D%5D,"Customer":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":20%7D%5D,"Issued":%5B%7B"type":"anytime","values":%5B%7B"date":"2020-09-16T15:33:17.693Z","constant":"7","unit":"day","tz":true%7D,%7B%7D%5D,"variant":"absolute","id":27%7D%5D,"Registered":%5B%7B"type":"anytime","values":%5B%7B%7D,%7B%7D%5D,"id":22%7D%5D,"Payment%20due":%5B%7B"type":"anytime","values":%5B%7B%7D,%7B%7D%5D,"id":23%7D%5D,"Paid":%5B%7B"type":"anytime","values":%5B%7B%7D,%7B%7D%5D,"id":24%7D%5D,"Brutto%20value":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":25%7D%5D,"Production%20manager":%5B%7B"type":"%3D","values":%5B%7B"constant":"${uriName}"%7D,%7B%7D%5D,"id":26%7D%5D%7D`;
};

const myNeedFixes = (name: string) => {
  const uriName = encodeURIComponent(name);

  return `${invoicesUrl}?Type=&State=need%20fixes&Customer=&Issued=&Registered=&Payment%20due=&Paid=&Brutto%20value=&Production%20manager=${uriName}&filter_config=%7B"Type":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":18%7D%5D,"State":%5B%7B"type":"%3D","values":%5B%7B"constant":"need%20fixes"%7D,%7B%7D%5D,"id":19%7D%5D,"Customer":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":20%7D%5D,"Issued":%5B%7B"type":"anytime","values":%5B%7B"date":"2020-09-16T15:33:17.693Z","constant":"7","unit":"day","tz":true%7D,%7B%7D%5D,"variant":"absolute","id":27%7D%5D,"Registered":%5B%7B"type":"anytime","values":%5B%7B%7D,%7B%7D%5D,"id":22%7D%5D,"Payment%20due":%5B%7B"type":"anytime","values":%5B%7B%7D,%7B%7D%5D,"id":23%7D%5D,"Paid":%5B%7B"type":"anytime","values":%5B%7B%7D,%7B%7D%5D,"id":24%7D%5D,"Brutto%20value":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":25%7D%5D,"Production%20manager":%5B%7B"type":"%3D","values":%5B%7B"constant":"${uriName}"%7D,%7B%7D%5D,"id":26%7D%5D%7D`;
};

const myNotYetPaid = (name: string) => {
  const uriName = encodeURIComponent(name);

  return `${invoicesUrl}?Type=&State=published&Customer=&Issued=&Registered=&Payment%20due=&Paid=NULL&Brutto%20value=&Production%20manager=${uriName}&filter_config=%7B"Type":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":18%7D%5D,"State":%5B%7B"type":"%3D","values":%5B%7B"constant":"published"%7D,%7B%7D%5D,"id":19%7D%5D,"Customer":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":20%7D%5D,"Issued":%5B%7B"type":"anytime","values":%5B%7B"date":"2020-09-16T15:33:17.693Z","constant":"7","unit":"day","tz":true%7D,%7B%7D%5D,"variant":"absolute","id":27%7D%5D,"Registered":%5B%7B"type":"anytime","values":%5B%7B%7D,%7B%7D%5D,"id":22%7D%5D,"Payment%20due":%5B%7B"type":"anytime","values":%5B%7B%7D,%7B%7D%5D,"id":23%7D%5D,"Paid":%5B%7B"type":"null","values":%5B%7B%7D,%7B%7D%5D,"id":24%7D%5D,"Brutto%20value":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":25%7D%5D,"Production%20manager":%5B%7B"type":"%3D","values":%5B%7B"constant":"${uriName}"%7D,%7B%7D%5D,"id":26%7D%5D%7D`;
};

const myInvoicesToProcess = (name: string) => {
  const uriName = encodeURIComponent(name);

  return `/embed/dashboards-next/82?Sales%20Assistant=${uriName}&Provider=&filter_config=%7B"Sales%20Assistant":%5B%7B"type":"%3D","values":%5B%7B"constant":"${uriName}"%7D,%7B%7D%5D,"id":4%7D%5D,"Provider":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":5%7D%5D%7D`;
};

const newMyInvoicesToProcess = (name: string) => {
  const uriName = encodeURIComponent(name);
  const tomorrow = encodeURIComponent(dayjs().add(1, 'days').format('YYYY-MM-DD'));

  return `/embed/dashboards/286?Arrival%20date=&Approval=Prepared%20by%20Partner,Manager%20is%20fixing&Hold%20till%20date=before%20${tomorrow},NULL&Production%20manager=${uriName}&Show%20deleted=No`;
};

const today = dayjs().format('YYYY-MM-DD');

const getUserNameForLooker = () => {
  if (typeof window === 'undefined') return '';

  try {
    const rawUserName = localStorage.getItem(UserLocStore.name) ?? '';

    return encodeURIComponent(rawUserName);
  } catch {
    return '';
  }
};

const userName = getUserNameForLooker();

const customerBalancesConfig: Record<Regions, string> = {
  [Regions.EU]: `/embed/dashboards/2676?Kam=&Pipedrive ID=&Org. name=&Fin Region=&Country=&PM=&Overdue Dunning=&On Date=${today}&Process Type=&Paid Date=&Pod ID=&Has Active Claim (Yes %2F No)=No&Cash Collection Status=&Intercompany=&Negotiated Due Date=&Invoice Balance=>%3D1`,
  [Regions.TR]: `/embed/dashboards/2780?On%20Date=${today}&Overdue=>0`,
  [Regions.UK]: `/embed/dashboards/3333?On%20Date=${today}&Overdue=>0`,
  [Regions.SG]: `/embed/dashboards/3333?On%20Date=${today}&Overdue=>0`, // TODO: SG
};

const partnerBalances = `/embed/dashboards/2831?ERP+Instance=${CURRENT_REGION}`;

const wonDealsByRegion: Record<Regions, string> = {
  [Regions.EU]:
    '/embed/dashboards/2560?Deal+Process=&Sales+Person+Region=&Salesperson=&Deal+Process+Group=&Customer+Order+Date=&ERP+Instance=EU&Quote+Type=&Deal+Created+At=this+year&Customer+Order+Grade=&Deal+Material+Type=&Customer+Type=',
  [Regions.TR]:
    '/embed/dashboards/2560?Deal+Process=&Sales+Person+Region=&Salesperson=&Deal+Process+Group=&Customer+Order+Date=&ERP+Instance=TR&Quote+Type=&Deal+Created+At=this+year&Customer+Order+Grade=&Deal+Material+Type=&Customer+Type=',
  [Regions.UK]:
    '/embed/dashboards/2560?Deal+Process=&Sales+Person+Region=&Salesperson=&Deal+Process+Group=&Customer+Order+Date=&ERP+Instance=UK&Quote+Type=&Deal+Created+At=this+year&Customer+Order+Grade=&Deal+Material+Type=&Customer+Type=',
  [Regions.SG]:
    '/embed/dashboards/2560?Deal+Process=&Sales+Person+Region=&Salesperson=&Deal+Process+Group=&Customer+Order+Date=&ERP+Instance=UK&Quote+Type=&Deal+Created+At=this+year&Customer+Order+Grade=&Deal+Material+Type=&Customer+Type=', // TODO: SG
};

const lstDealsByRegion: Record<Regions, string> = {
  [Regions.EU]:
    '/embed/dashboards/2141?Deal+Process=&Sales+Person+Region=&Salesperson=&Reason+of+Lose=before+order%3A+too+long+delivery%2Cbefore+order%3A+too+high+price%2Cbefore+order%3A+shipping+price+too+high%2Cbefore+order%3A+refused+by+xom+%28out+of+scope%29%2Cbefore+order%3A+quoted+too+late%2Cbefore+order%3A+prefer+local+supplier%2Cbefore+order%3A+prefer+in-house+production%2Cbefore+order%3A+customer+put+the+project+on+hold%2Cbefore+order%3A+client+unhappy+with+our+past+service&Deal+Process+Group=&Customer+Order+Date=&ERP+Instance=EU&Quote+Type=&Deal+Created+At=2023&Customer+Order+Grade=&Deal+Material+Type=&Customer+Type=',
  [Regions.TR]:
    '/embed/dashboards/2141?Deal+Process=&Sales+Person+Region=&Salesperson=&Reason+of+Lose=before+order%3A+too+long+delivery%2Cbefore+order%3A+too+high+price%2Cbefore+order%3A+shipping+price+too+high%2Cbefore+order%3A+refused+by+xom+%28out+of+scope%29%2Cbefore+order%3A+quoted+too+late%2Cbefore+order%3A+prefer+local+supplier%2Cbefore+order%3A+prefer+in-house+production%2Cbefore+order%3A+customer+put+the+project+on+hold%2Cbefore+order%3A+client+unhappy+with+our+past+service&Deal+Process+Group=&Customer+Order+Date=&ERP+Instance=TR&Quote+Type=&Deal+Created+At=2023&Customer+Order+Grade=&Deal+Material+Type=&Customer+Type=',
  [Regions.UK]:
    '/embed/dashboards/2141?Deal+Process=&Sales+Person+Region=&Salesperson=&Reason+of+Lose=before+order%3A+too+long+delivery%2Cbefore+order%3A+too+high+price%2Cbefore+order%3A+shipping+price+too+high%2Cbefore+order%3A+refused+by+xom+%28out+of+scope%29%2Cbefore+order%3A+quoted+too+late%2Cbefore+order%3A+prefer+local+supplier%2Cbefore+order%3A+prefer+in-house+production%2Cbefore+order%3A+customer+put+the+project+on+hold%2Cbefore+order%3A+client+unhappy+with+our+past+service&Deal+Process+Group=&Customer+Order+Date=&ERP+Instance=UK&Quote+Type=&Deal+Created+At=2023&Customer+Order+Grade=&Deal+Material+Type=&Customer+Type=',
  [Regions.SG]:
    '/embed/dashboards/2141?Deal+Process=&Sales+Person+Region=&Salesperson=&Reason+of+Lose=before+order%3A+too+long+delivery%2Cbefore+order%3A+too+high+price%2Cbefore+order%3A+shipping+price+too+high%2Cbefore+order%3A+refused+by+xom+%28out+of+scope%29%2Cbefore+order%3A+quoted+too+late%2Cbefore+order%3A+prefer+local+supplier%2Cbefore+order%3A+prefer+in-house+production%2Cbefore+order%3A+customer+put+the+project+on+hold%2Cbefore+order%3A+client+unhappy+with+our+past+service&Deal+Process+Group=&Customer+Order+Date=&ERP+Instance=UK&Quote+Type=&Deal+Created+At=2023&Customer+Order+Grade=&Deal+Material+Type=&Customer+Type=', // TODO: SG
};

const salesTargetsByRegion: Record<Regions, string> = {
  [Regions.EU]: '/embed/dashboards/2403',
  [Regions.TR]: '/embed/dashboards/2403?Kam=&Sales+Person+Region=Turkey&Job+Title=&Month+Date=this+quarter',
  [Regions.UK]: '/embed/dashboards/2403?Kam=&Sales+Person+Region=UK%2FIE&Job+Title=&Month+Date=this+year',
  [Regions.SG]: '/embed/dashboards/2403?Kam=&Sales+Person+Region=UK%2FIE&Job+Title=&Month+Date=this+year', // TODO: SG
};

const salespeoplePerformanceByRegion: Record<Regions, string> = {
  [Regions.EU]:
    '/embed/dashboards/3232?Kam=&Sales+Person+Region=DACH&Job+Title=&Period=this+year&Date+Granularity=Month',
  [Regions.TR]:
    '/embed/dashboards/3232?Sales+Person=&Sales+Person+Region=Turkey&Job+Title=&Period=this+year&Date+Granularity=Month',
  [Regions.UK]:
    '/embed/dashboards/3232?Sales+Person=&Sales+Person+Region=UK%2FIE&Job+Title=&Period=this+year&Date+Granularity=Month',
  [Regions.SG]:
    '/embed/dashboards/3232?Sales+Person=&Sales+Person+Region=UK%2FIE&Job+Title=&Period=this+year&Date+Granularity=Month', // TODO: SG
};

const customerBalancesLooker = customerBalancesConfig[CURRENT_REGION];
const wonDeals = wonDealsByRegion[CURRENT_REGION];
const lostDeals = lstDealsByRegion[CURRENT_REGION];
const salesTargets = salesTargetsByRegion[CURRENT_REGION];
const salespeoplePerformance = salespeoplePerformanceByRegion[CURRENT_REGION];

export default {
  crm: {
    deals: {
      today: '/embed/dashboards/276?Arrival%20date=1%20days&Deal%20status=open',
      last7Days: '/embed/dashboards/276?Arrival%20date=7%20days&Deal%20status=open',
      todayOrders: '/embed/dashboards/276?Arrival%20date=&Deal%20status=open&Order%20date=1%20days',
      last7DaysOrders: '/embed/dashboards/276?Arrival%20date=&Deal%20status=open&Order%20date=7%20days',
      won2021: '/embed/dashboards/276?Arrival%20date=&Deal%20status=won&Order%20date=2021',
    },
    orgs: '/embed/dashboards/282',
    persons: '/embed/dashboards/279',
    cross: '/embed/dashboards/220',
    promotions: '/embed/dashboards/333',
  },
  finance: {
    outcomingInvoices: {
      all: `${invoicesUrl}?Type=&State=&Customer=&Issued=after%2060%20days%20ago&Registered=&Payment%20due=&Paid=&Brutto%20value=&Production%20manager=&filter_config=%7B"Type":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":18%7D%5D,"State":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":19%7D%5D,"Customer":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":20%7D%5D,"Issued":%5B%7B"type":"after","values":%5B%7B"constant":"60","unit":"day"%7D,%7B%7D%5D,"variant":"relative","id":21%7D%5D,"Registered":%5B%7B"type":"anytime","values":%5B%7B%7D,%7B%7D%5D,"id":22%7D%5D,"Payment%20due":%5B%7B"type":"anytime","values":%5B%7B%7D,%7B%7D%5D,"id":23%7D%5D,"Paid":%5B%7B"type":"anytime","values":%5B%7B%7D,%7B%7D%5D,"id":24%7D%5D,"Brutto%20value":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":25%7D%5D,"Production%20manager":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":26%7D%5D%7D`,
      readyForCheck: `${invoicesUrl}}?Type=&State=ready%20for%20check&Customer=&Issued=after%2060%20days%20ago&Registered=&Payment%20due=&Paid=&Brutto%20value=&Production%20manager=&filter_config=%7B"Type":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":18%7D%5D,"State":%5B%7B"type":"%3D","values":%5B%7B"constant":"ready%20for%20check"%7D,%7B%7D%5D,"id":19%7D%5D,"Customer":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":20%7D%5D,"Issued":%5B%7B"type":"after","values":%5B%7B"constant":"60","unit":"day"%7D,%7B%7D%5D,"variant":"relative","id":21%7D%5D,"Registered":%5B%7B"type":"anytime","values":%5B%7B%7D,%7B%7D%5D,"id":22%7D%5D,"Payment%20due":%5B%7B"type":"anytime","values":%5B%7B%7D,%7B%7D%5D,"id":23%7D%5D,"Paid":%5B%7B"type":"anytime","values":%5B%7B%7D,%7B%7D%5D,"id":24%7D%5D,"Brutto%20value":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":25%7D%5D,"Production%20manager":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":26%7D%5D%7D`,
      my: {
        all: myInvoicesUrl,
        needFixes: myNeedFixes,
        notYetPaid: myNotYetPaid,
      },
    },
    paymentBalance: {
      overview: '/embed/dashboards/171',
      detailed: '/embed/dashboards/166',
    },

    customerBalances: customerBalancesLooker,

    partnerBalances,

    customersCash: '/embed/dashboards/142',

    partnerInvoices: {
      old: {
        all: '/embed/dashboards/143',
        myToProcess: myInvoicesToProcess,
        dash: '/embed/dashboards/79',
        toEnterToIntacct: '/embed/dashboards/83',
        toEnterToDatev: '/embed/dashboards/83',
        // Why same IDs?
        toEnterToAccountingId: '/embed/dashboards/83',
        toBePaid: '/embed/dashboards/84',
        missingOrMismatch: '/embed/dashboards/86',
      },
      new: {
        all: '/embed/dashboards/284',
        myToProcess: newMyInvoicesToProcess,
        toCheck: '/embed/dashboards/287',
        toEnterToIntacct: '/embed/dashboards/288',
        toEnterToDatev: '/embed/dashboards/288',
        // Why same IDs?
        toEnterToAccountingId: '/embed/dashboards/288',
        toBePaid: '/embed/dashboards/285',
        partnersSide: '/embed/dashboards/289',
      },
    },
  },
  sales: {
    quotes: '/embed/dashboards/329',
    coupons: '/embed/dashboards/333',
    dfmChecks: '/embed/dashboards/209',
    drawingsCleaning: '/embed/dashboards/210',
    analytics: {
      bdmPerformance: '/embed/dashboards/1313',
      ordersCurrentMonth: '/embed/dashboards/1306',
      kamQuotations: '/embed/dashboards/1301',
      monthlySalesMetricsPath: '/embed/dashboards/428',
      npg: '/embed/dashboards/1385',
      clientDevelopmentDashboard: '/embed/dashboards/2324',
      wonDeals,
      lostDeals,
      salesTargets,
      salespeoplePerformance,
      quickClosingClients: '/embed/dashboards/3775',
      spWeeklyDigest: '/embed/dashboards/4048',
      salesKpi: '/embed/dashboards/4455',
      emeaSalesKpis: '/embed/dashboards/6558',
      saDashboard: `/embed/dashboards/2306?Deal+Created+At+=this+month&ERP+Instance=${CURRENT_REGION === Regions.TR ? 'TR' : 'EU%2CUK'}&Sales+Person+Region=&Quote+Type=&Deal+Process+Group=`,
      customerOverdue:
        '/embed/dashboards/4343?ERP+Instance=&Sales+Region=-Other&PM+Name=&Sales+Person=&Customer+Country=&POD=&Customer+Name=&Bad+Payer+(Yes+%2F+No)=&Has+Active+Claim+(Yes+%2F+No)=No&Quote+Type=&Is+Framework+Agreement+(Yes+%2F+No)=&AR+Overdue+Dunning+(EUR)=>100&Organization+Name=-Northvolt&Deal+ID=-840218%2C-918241&Former+member+Type=&Sales+Team=',
      spScoreCard: `/embed/dashboards/5415?Period=after+2025%2F01%2F01&Sales+Person+Region=&Sales+Team=&Sales+Person+Name=${userName}&Job+Title=`,
      salesTeamPerformanceComparisonYoy:
        '/embed/dashboards/5065?Sales+Team=&Sales+Person+Name=&Deal+ERP+ID=-EU-840218&Is+Xometry+Intercompany+%28Yes+%2F+No%29=No&Period+1=last+year&Period+2=this+year',
      speedToLeadAnalysis: `/embed/dashboards/6397?ERP+Instance=${CURRENT_REGION}`,
    },
    castingAndMolding: {
      engineerFeedback: '/embed/dashboards/4144',
      dfmPerformanceDashboard: '/embed/dashboards/5331',
    },
  },
  drawings: {
    tagErrors: `/embed/dashboards/1950?Erp+Instance=${CURRENT_REGION}&Audit+Updated+by+Name=&Pipedrive+Status=`,
  },
  production: {
    warehouseOverview: '/embed/dashboards/862',
    dfmDrawingsOverview: '/embed/dashboards/1637',
    productionOrders: '/embed/dashboards/292',
    po: {
      noHs: '/embed/dashboards-next/363',
    },
    daily: {
      indicators: '/embed/dashboards/71',
    },
    pm: {
      workload: '/embed/dashboards/109',
    },
    differenceAnalysis: '/embed/dashboards/3211',
    providersLoadDashboard: `/embed/dashboards/5917?ERP+Instance=${CURRENT_REGION}&PO+Report+Date=before+10+week+from+now&Is+Framework+Agreement=No&Is+Secondary+Production=No&Is+TPO+Deal=&Metric+Name=&Provider+ID=&Is+Next+Week+Red+Value=Yes&Is+PO+for+Xometry+US=&PNM+Name=${userName}`,
    quality: {
      qualityControl: '/embed/dashboards/178',
    },
    jobs: {
      info: '/embed/dashboards-next/358?Publication+Start+Date=after+1+months+ago&Customer+Grade=Class+A%2CClass+B&Job+State=active&Job+Has+3d+Part=No',
      list: '/embed/dashboards/179',
      lackOfGraphic: '/embed/dashboards-next/295',
      generalBoard:
        '/embed/dashboards/235?Job%20ID=&Tags=%25cnc%25,%25sheet%25,%25other%25&Publication%20Start%20Date=after%202021%2F01%2F01&Start%20Margin=&Hours%20Before%20Placed=&Decision%20State=&Counter%20Offer%20Margin=%5B-1,%201%5D&Job%20State=placed&filter_config=%7B"Job%20ID":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":16%7D%5D,"Tags":%5B%7B"type":"contains","values":%5B%7B"constant":"cnc,sheet,other"%7D,%7B%7D%5D,"id":17%7D%5D,"Publication%20Start%20Date":%5B%7B"type":"after","values":%5B%7B"date":"2021-01-01T11:57:10.456Z","constant":"7","unit":"day","tz":true%7D%5D,"variant":"absolute","id":18%7D%5D,"Start%20Margin":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":19%7D%5D,"Hours%20Before%20Placed":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":20%7D%5D,"Decision%20State":%5B%7B"type":"%3D","values":%5B%7B"constant":""%7D,%7B%7D%5D,"id":21%7D%5D,"Counter%20Offer%20Margin":%5B%7B"type":"between","values":%5B%7B"constant":"-1"%7D,%7B"constant":"1"%7D%5D,"variant":"%5B%5D","id":22%7D%5D,"Job%20State":%5B%7B"type":"%3D","values":%5B%7B"constant":"placed"%7D,%7B%7D%5D,"id":23%7D%5D%7D',
      offers: {
        all: '/embed/dashboards/183',
        navigationAll: '/embed/dashboards/198?Job%20Offer%20Created%20At=after%203%20days%20ago',
        decisionNeeded: '/embed/dashboards/198',
      },
    },
  },
  logistics: {
    warehouse: '/embed/dashboards/177',
    analytics: {
      logisticsAutomation:
        '/embed/dashboards/6051?Date+Range=3+month&ERP+Instance=EU%2CUK%2CTR&Source+Country=&Date+Granularity=Week&Container+Type=&Shipping+State=delivered%2C%22in_transit%22%2C%22ready_for_shipping%22%2C%22shipping_ordered%22&Destination+Country=%23N%2FA%2C1%2CAndorra%2CArmenia%2CAustralia%2CAustria%2CBelgium%2CBosnia+and+Herzegovina%2CBrazil%2CBulgaria%2CCanada%2CCanary+Islands+%E2%80%93+Spain%2CChile%2CChina%2CColombia%2CCosta+Rica%2CCroatia%2CCyprus%2CCzech+Republic%2CCzechia%2CDenmark%2CEstonia%2CFinland%2CFrance%2CFrench+Polynesia%2CGeorgia%2CGermany%2CGibraltar%2CGreece%2CGuadeloupe%2CGuernsey%2CHong+Kong%2CHungary%2CIceland%2CIndia%2CIndonesia%2CIreland%2CIsrael%2CItaly%2CJapan%2CJersey%2CJordan%2CKazakhstan%2C%22Korea%2C+Republic+of%22%2CKosovo%2CKuwait%2CLatvia%2CLebanon%2CLiechtenstein%2CLithuania%2CLuxembourg%2CMacedonia%2C%22Macedonia%2C+The+Former+Yugoslav+Republic+of%22%2CMalaysia%2CMalta%2CMartinique%2CMexico%2CMoldova%2CMonaco%2CMontenegro%2CNetherlands%2CNew+Zealand%2CNorthern+Ireland%2CNorway%2CPhilippines%2CPoland%2CPortugal%2CPuerto+Rico%2CRWANDA%2CRomania%2CRussian+Federation%2CSan+Marino%2CSaudi+Arabia%2CSerbia%2CSingapore%2CSlovakia%2CSlovenia%2CSouth+Africa%2CSpain%2CSri+Lanka%2CSwaziland%2CSweden%2CSwitzerland%2CTaiwan%2CThailand%2CTurkey%2CT%C3%BCrkiye%2CUnited+Arab+Emirates%2CUnited+Kingdom%2CViet+Nam%2CVietnam%2CZambia%2C%C3%85land+Islands&Is+Mirror+Shipping+%28Yes+%2F+No%29=No&Sh+ID=',
    },
  },
  partners: {
    list: '/embed/dashboards/314',
    kpi: '/embed/dashboards/456',
    instantPay: '/embed/dashboards-next/403',
    expressOrders: '/embed/dashboards-next/560',
    ratingByParts: (providerId: number | string) =>
      `/embed/dashboards/2168?Provider+ID=${providerId}&Current+Erp+Instance=${CURRENT_REGION}&Is+Affecting+Rating+%28Yes+%2F+No%29=Yes`,
    network: {
      claimAndDelay: '/embed/dashboards/857',
      providersByCohorts: '/embed/dashboards/813',
      generalInfo: '/embed/dashboards/267',
      competenceBalance: '/embed/dashboards/117',
      profiles: '/embed/dashboards/164',
      performance: '/embed/dashboards/159',
      newbies: '/embed/dashboards/239',
    },
    cPool: {
      po: '/embed/dashboards/324',
      partners: '/embed/dashboards/321',
      analytics: '/embed/dashboards-next/327',
    },
    engagement: {
      poByCountryAnalysis: '/embed/dashboards/258',
      lifetimeMilestones: '/embed/dashboards/157',
      testPart: '/embed/dashboards/161',
      trusted: '/embed/dashboards/261',
      onboarding: '/embed/dashboards/160',
      probation: '/embed/dashboards/163',
    },
  },
};
